import { render, staticRenderFns } from "./ModalInfo.vue.js?vue&type=template&id=97ed5d9e!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ModalInfo.vue?vue&type=template&id=97ed5d9e"
import script from "./ModalInfo.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ModalInfo.vue?vue&type=script&lang=js"
export * from "./ModalInfo.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ModalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports